import { GROUP_HEADER_DROPDOWN_ICON_SIZE } from "../types/constants";
import { Add as AddIcon, ArrowDropDown } from "@mui/icons-material";
import { Box, IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import * as labels from "config.labels";
import React, { useState } from "react";
import * as staticDataHooks from "store/hooks/staticDataHooks";

const stopPropagation = (e) => e.stopPropagation();

const GroupByAggregateMenu = ({ field, options, onAddAggregateColumn }) => {
  const translateLabels = staticDataHooks.useTranslator("uiLabels");
  const [anchorEl, setAnchorEl] = useState(null);
  const title = translateLabels(labels.HEADER_GROUP_BY_ADD_FUNCTION_COLUMN, {
    default: "Add column using a function",
  });

  const addColumn = (opt) => {
    onAddAggregateColumn(field, opt.value, opt.label);
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip title={title}>
        <IconButton
          size={"small"}
          aria-label={title}
          onMouseDown={stopPropagation}
          onContextMenu={stopPropagation}
          onClick={(e) => {
            e.stopPropagation();
            setAnchorEl(e.currentTarget);
          }}
          sx={{ p: "1px", flexShrink: 0 }}
        >
          <ArrowDropDown
            sx={{
              fontSize: GROUP_HEADER_DROPDOWN_ICON_SIZE,
              color: "text.secondary",
            }}
          />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        onClick={stopPropagation}
        onMouseDown={stopPropagation}
        onContextMenu={stopPropagation}
      >
        {options.map((opt) => (
          <MenuItem
            key={opt.value}
            dense
            onClick={() => addColumn(opt)}
            sx={{
              fontSize: "0.75rem",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              pr: 0.5,
              gap: 1,
            }}
          >
            <Box component={"span"} sx={{ flex: 1 }}>
              {opt.label}
            </Box>
            <IconButton
              size={"small"}
              aria-label={translateLabels(labels.ADD_AGGREGATE_COLUMN_ADD, {
                default: "Add {name} column",
                replacements: { name: opt.label },
              })}
              onMouseDown={(e) => {
                e.stopPropagation();
                e.preventDefault();
              }}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                addColumn(opt);
              }}
              sx={{
                p: "2px",
                color: "text.secondary",
                "&:hover": { color: "primary.main" },
              }}
            >
              <AddIcon sx={{ fontSize: "1.6rem" }} />
            </IconButton>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default GroupByAggregateMenu;
